export const CLEAR_ERRORS_CUSTOMERS_ATTACHMENTS = 'CLEAR_ERRORS_CUSTOMERS_ATTACHMENTS';
